import { Component, OnInit,Input } from '@angular/core';
import { DatagridOptions } from '../utils/datagrid-options';

@Component({
  selector: 'lib-data-table',
  template: `<div>
  <p-table #dt [columns]="cols" [value]="rows">
    <ng-template pTemplate="caption" *ngIf="globalFilter">
        <div style="text-align: right">        
            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
            <input type="text" pInputText size="50" placeholder="Global Filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
        </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns">
          {{col.header}}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns">
          {{rowData[col.field]}}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>`,
  styles: [``]
})
export class DataTableComponent implements OnInit {



 @Input() options: DatagridOptions;

  cols: any[];
  rows = [];
  globalFilter : boolean = false;

  constructor() {}
  


ngOnInit() {
    this.cols = this.options.col;
    this.rows = this.options.rows;
    this.globalFilter = this.options.globalFilter;
  }
}
